import { render, staticRenderFns } from "./MenuLinks.vue?vue&type=template&id=351f6ff9&scoped=true"
import script from "./MenuLinks.vue?vue&type=script&lang=js"
export * from "./MenuLinks.vue?vue&type=script&lang=js"
import style0 from "./MenuLinks.vue?vue&type=style&index=0&id=351f6ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f6ff9",
  null
  
)

export default component.exports